import React, { Component, Fragment } from "react";
import { CRUDFunction } from "../../reduxCURD/container";
import SpinnerLoader from "../Common/SpinnerLoader";
import { trackReportStyle } from "../Reports/Timps/style";
import { languageService } from "Language/language.service";
import { themeService } from "../../theme/service/activeTheme.service";
import { Col, Row } from "reactstrap";
import { updateFilterState } from "../../reduxRelated/actions/filterStateAction";
import DateRangeControl from "../Common/DateRange/DateRangeControl";
import moment from "moment";
import BlueCardReportView from "./BlueCardReportView";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import SvgIcon from "react-icons-kit";
import { printer } from "react-icons-kit/icomoon/printer";
import { ButtonActionsTable } from "components/Common/Buttons";
import { getBlueCardAssets } from "../../reduxRelated/actions/assetHelperAction";
// import "../Timps/style/style.css";
import { calendar } from "react-icons-kit/icomoon/calendar";
import Icon from "react-icons-kit";
import { curdActions } from "../../reduxCURD/actions";

class BlueCardReport extends Component {
  constructor(props) {
    super(props);
    this.blueCardReportFilter = this.props.blueCardReportFilter
      ? this.props.blueCardReportFilter
      : { submit: true, year: moment().year(Number).format("YYYY") };
    this.state = {
      spinnerLoading: false,
      pInspecSchedule: "Scheduled",
      selectedBlueCardReport: null,
      showBlueCard: false,
      dateRange: {
        from: new Date(moment().startOf("month")),
        today: new Date(moment().startOf("day")),
        to: new Date(moment().endOf("month")),
      },
      ...this.blueCardReportFilter,
    };
    this.updateDateRange = this.updateDateRange.bind(this);
    this.handleUpdateFilterState = this.handleUpdateFilterState.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.isApp = this.isApp.bind(this);
  }

  handleUpdateFilterState(propertiesToUpdate) {
    let blueCardReportFilter = this.props.blueCardReportFilter ? this.props.blueCardReportFilter : {};

    this.props.updateFilterState("blueCardReportFilter", {
      ...blueCardReportFilter,
      ...propertiesToUpdate,
    });
  }

  updateDateRange(dateRange, stateRange, inspecSchedule) {
    this.setState({
      dateRange: dateRange,
      pInspecSchedule: inspecSchedule,
      ...stateRange,
    });

    this.props.getBlueCardAssets(stateRange.year);
  }
  isApp = () => localStorage.getItem("source");

  handleClick(asset) {
    let arg = "?year=" + this.state.year + "&assetId=" + asset._id.toString();
    this.props.getBlueCards("/getBlueCard" + arg);

    this.setState({
      showBlueCard: true,
    });
  }

  handleBack() {
    this.setState({
      showBlueCard: false,
      selectedBlueCardReport: null,
    });
  }
  componentDidMount() {
    this.props.getBlueCardAssets(this.state.year);

    if (this.props.location) {
      let location = this.props.location;
      let { state } = location;
      if (state) {
        this.handleClick({ _id: state.assetId });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.assetHelperActionType == "GET_BLUECARDASSETS_REQUEST" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      this.setState({
        spinnerLoading: true,
      });
    }

    if (
      this.props.assetHelperActionType == "GET_BLUECARDASSETS_FAILURE" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      this.setState({
        spinnerLoading: false,
      });
    }
    if (
      this.props.assetHelperActionType == "GET_BLUECARDASSETS_SUCCESS" &&
      this.props.assetHelperActionType !== prevProps.assetHelperActionType
    ) {
      this.props.getApplicationlookupss(["blueCardSections"]);
    }

    if (
      this.props.applicationlookupsActionType == "APPLICATIONLOOKUPSS_READ_FAILURE" &&
      this.props.applicationlookupsActionType !== prevProps.applicationlookupsActionType
    ) {
      this.setState({
        spinnerLoading: false,
      });
    }
    if (
      this.props.applicationlookupsActionType == "APPLICATIONLOOKUPSS_READ_SUCCESS" &&
      this.props.applicationlookupsActionType !== prevProps.applicationlookupsActionType
    ) {
      this.setState({
        spinnerLoading: false,
      });
    }

    if (this.props.actionType == "BLUECARDS_READ_REQUEST" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: true,
      });
    }

    if (this.props.actionType == "BLUECARDS_READ_SUCCESS" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: false,
        selectedBlueCardReport: this.props.BlueCards,
      });
    }

    if (this.props.actionType == "BLUECARDS_READ_FAILURE" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: false,
      });
    }
  }
  render() {
    return (
      <div>
        <SpinnerLoader spinnerLoading={this.state.spinnerLoading} />

        {!this.state.showBlueCard && (
          <div className="mainContent" style={{ textAlign: "center" }}>
            <Col md={12}>
              <div className="mainContent commonform" style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}>
                {
                  <React.Fragment>
                    <h2 style={{ ...themeService(trackReportStyle.headingStyle), transform: "none", fontSize: "22px" }}>
                      {languageService("Blue Card Report")}
                    </h2>

                    <span>
                      <DateRangeControl
                        dateRangeChanged={this.updateDateRange}
                        handleUpdateFilterState={this.handleUpdateFilterState}
                        year={this.state.year}
                        submit={this.state.submit}
                        pInspecSchedule={this.state.pInspecSchedule}
                        includeScheduleOption={false}
                        minYear={2025}
                      />
                    </span>
                  </React.Fragment>
                }
              </div>
            </Col>
            <ReportSelection reports={this.props.blueCardAssets} handleClick={this.handleClick} />
          </div>
        )}

        {this.state.showBlueCard && (
          <React.Fragment>
            {" "}
            <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
              <div
                className="report-arrow"
                style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
                onClick={(e) => {
                  this.handleBack();
                }}
              >
                <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
                  {languageService("Reports Menu")}
                </span>
                <SvgIcon icon={arrowLeft} size={24} />
              </div>

              <div
                className="report-print"
                style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
                onClick={(e) => window.print()}
              >
                <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                  {languageService("Print Report")}
                </span>
                <SvgIcon icon={printer} size={24} />
              </div>
            </div>
            <BlueCardReportView
              reportData={this.state.selectedBlueCardReport}
              year={this.state.year}
              blueCardSectionsLookups={this.props.applicationlookupss}
            />
          </React.Fragment>
        )}
      </div>
    );
  }
}
const getApplicationlookupss = curdActions.getApplicationlookupss;
let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
  others: {
    updateFilterState,
    getBlueCardAssets,
    getApplicationlookupss,
  },
};

let variables = {
  filterStateReducer: {
    blueCardReportFilter: null,
  },
  assetHelperReducer: {
    blueCardAssets: [],
  },

  applicationlookupsReducer: { applicationlookupss: [] },
};

const BlueCardReportContainer = CRUDFunction(
  BlueCardReport,
  "BlueCard",
  actionOptions,
  variables,
  ["filterStateReducer", "assetHelperReducer", "applicationlookupsReducer"],
  "testSchedule",
);

export default BlueCardReportContainer;

const ReportSelection = (props) => {
  let rows =
    props.reports &&
    props.reports.length > 0 &&
    props.reports.map((asset, index) => {
      return (
        <tr key={index}>
          <td>{asset.unitId}</td>
          {/* <td>{asset.start}</td> */}
          <td>
            <ButtonActionsTable
              handleClick={(e) => {
                props.handleClick(asset);
              }}
              margin="0px 10px 0px 0px"
              buttonText={languageService("View")}
            />
          </td>
        </tr>
      );
    });
  return (
    <div
      className="mainContent table-report switch-side-track report-selection"
      style={{ ...themeService(trackReportStyle.mainStyle), background: "transparent" }}
    >
      <Row>
        <Col md={1}></Col>
        <Col md={10}>
          <table className="table-selection">
            <thead>
              <tr>
                <th data-field="assetName" style={{ width: "10px" }}>
                  {languageService("Asset")}
                </th>
                {/* 
                <th data-field="assetMP" style={{ width: "10px" }}>
                  {languageService("Location (milepost)")}
                </th> */}
                <th data-field="action" style={{ width: "10px" }}>
                  {languageService("Action")}
                </th>
              </tr>
            </thead>
            <tbody style={{ background: "var(--fifth)", fontSize: "12px" }}>{rows}</tbody>
          </table>
        </Col>
        <Col md={1}></Col>
      </Row>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/BlueCardReport/index.jsx